import { t } from 'i18next';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { RBACProvider } from '../context/RBACContext';
import { useTranslation } from "react-i18next";

interface ProtectedRouteProps {
    children: React.ReactNode;
    roles?: string[];
    moduleId?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, roles, moduleId }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
                    <p className="mt-4 text-gray-600">{t('ui_loading____8524de', `Loading...`)}</p>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // 1. Module-based Hidden Access Check (NONE)
    if (moduleId && user.permissions) {
        const perm = user.permissions.find((p: any) => p.moduleId === moduleId);
        if (perm && perm.level === 'NONE') {
            return <Navigate to="/dashboard" replace />;
        }
    }

    // 2. Role check if roles are provided
    if (roles && !roles.includes(user.role)) {
        return <Navigate to="/" replace />;
    }

    // 3. Block unapproved users
    if ((user.role === 'PARTNER' || user.role === 'DOCTOR' || user.role === 'HOSPITAL' || user.role === 'GROOMING_AGENCY' || user.role === 'DAYCARE' || user.role === 'TRAINER' || user.role === 'ECOMMERCE_AGENT') && user.isApproved === false) {
        return <Navigate to="/login" state={{ error: "Your account is waiting for approval." }} replace />;
    }

    // Wrap with RBACProvider to provide "Read Only" context to children
    return (
        <RBACProvider moduleId={moduleId}>
            {children}
        </RBACProvider>
    );
};
